import React, { Suspense, useMemo, useState } from "react";
import { Switch, Route } from "react-router";

import { SiteRoutes } from "./request/PathConfig";
import { UsuarioContext, SucursalesContext, SucursalContext } from "./Context.jsx";

const Layout = React.lazy(() => import("./containers/Layout"));
const Cliente = React.lazy(() => import("./containers/Cliente/index.jsx"));
const Ordenes = React.lazy(() => import("./containers/Ordenes/index.jsx"));
const Articulos = React.lazy(() => import("./containers/Articulos/index.jsx"));
const Error = React.lazy(() => import("./containers/Error/Error.jsx"));

const App = () => {
    const [Usuario, setUsuario] = useState(null);
    const UsuarioValor = useMemo(() => ({ Usuario, setUsuario }), [Usuario, setUsuario]);
    const [Sucursales, setSucursales] = useState(null);
    const SucursalesValor = useMemo(() => ({ Sucursales, setSucursales }), [Sucursales, setSucursales]);
    const [Sucursal, setSucursal] = useState(null);
    const SucursalValor = useMemo(() => ({ Sucursal, setSucursal }), [Sucursal, setSucursal]);

    return (
        <Suspense fallback={null}>
            <Switch>
                <Route
                    path={[
                        SiteRoutes.Cliente,
                        SiteRoutes.Ordenes,
                        SiteRoutes.Articulos,
                        SiteRoutes.Base,
                        SiteRoutes.Error,
                    ]}
                >
                    <UsuarioContext.Provider value={UsuarioValor}>
                        <SucursalesContext.Provider value={SucursalesValor}>
                            <SucursalContext.Provider value={SucursalValor}>
                                <Layout>
                                    <Switch>
                                        <Route path={SiteRoutes.Cliente} component={Cliente} />
                                        <Route path={SiteRoutes.Ordenes} component={Ordenes} />
                                        <Route path={SiteRoutes.Articulos} component={Articulos} />
                                        <Route path={SiteRoutes.Error} component={Error} />
                                        <Route component={Cliente} path={SiteRoutes.Base} />
                                        <Route component={Cliente} />
                                    </Switch>
                                </Layout>
                            </SucursalContext.Provider>
                        </SucursalesContext.Provider>
                    </UsuarioContext.Provider>
                </Route>
            </Switch>
        </Suspense>
    );
};

export default App;
